import '@fortawesome/fontawesome-free/css/all.css'
import 'vuetify/dist/vuetify.min.css'

import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/es5/util/colors'

Vue.use(Vuetify);

const options = {
  theme: {
    themes: {
      light: {
        info: colors.grey.darken4,
        primary: colors.grey.darken4,
        accent: colors.shades.black,
      }
    }
  }
}

export default new Vuetify(options)
